import React, { useState } from 'react';
import taskIcon from '../../../../images/icons/task.svg';
import dealIcon from '../../../../images/icons/001-deal.svg';
import stopclockIcon from '../../../../images/icons/002-stopclock.svg';
import { MdMoreVert as MenuIcon } from '@react-icons/all-files/md/MdMoreVert';
import Stats from './components/Stats';
import { createUseStyles } from '../../../../theming';
import EmployeeSelect from './components/EmployeeSelect';
import { LegacyUser } from '../../../../interfaces/api/User';
import { Divider, IconButton, Popover } from '@material-ui/core';
import Card from '../../../../components/Card';

const apiDealGetStats = '/api/deal/stats';
const apiReminderGetStats = '/api/reminder/stats';
const apiTaskGetStats = '/api/task/stats';

const useStyles = createUseStyles({
  root: {
    boxShadow: '0 0 35px 0 rgba(154,161,171,.15)',
    marginBottom: 24,
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    minWidth: '0',
    wordWrap: 'break-word',
    backgroundColor: '#fff',
    backgroundClip: 'initial',
    border: '1px solid #eef2f7',
    borderRadius: '.25rem',
  },
  statsContainer: {
    display: 'flex',
    marginBottom: 16,
    marginTop: 16,
  },
  settingsMenu: {
    margin: 16,
  },
  menuBttn: {
    position: 'absolute',
    right: 3,
    top: 3,
  },
});

interface Props {
  user: LegacyUser;
}

const StatsContainer: React.FC<Props> = ({ user }) => {
  const classes = useStyles();
  const [selectedUserId, setSelectedUserId] = useState<number>(user.id);
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

  const settingsOpen = Boolean(anchorEl);

  return (
    <Card className={classes.root}>
      <div className={classes.menuBttn}>
        <IconButton onClick={(event) => setAnchorEl(event.currentTarget)}>
          <MenuIcon />
        </IconButton>
      </div>

      <Popover
        open={settingsOpen}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        onClose={() => setAnchorEl(null)}
      >
        <div className={classes.settingsMenu}>
          <EmployeeSelect userId={selectedUserId} onChange={setSelectedUserId} />
        </div>
      </Popover>

      <div className={classes.statsContainer}>
        <Stats endpoint={apiDealGetStats} icon={dealIcon} userId={selectedUserId} title='Affaires en cours' />

        <Divider component='div' orientation='vertical' flexItem />

        <Stats endpoint={apiTaskGetStats} icon={taskIcon} userId={selectedUserId} title='Tâches en cours' />

        <Divider component='div' orientation='vertical' flexItem />

        <Stats endpoint={apiReminderGetStats} icon={stopclockIcon} userId={selectedUserId} title='Rappels en cours' />
      </div>
    </Card>
  );
};

export default StatsContainer;
